import React, { FC } from 'react';

import { ModalGridItem } from 'components/molecules';
import { useLocale } from 'lib';
import { mdiPhone } from '@mdi/js';
import type { ContactOptionModalItemProps } from '..';

export const PhoneCallOption: FC<ContactOptionModalItemProps> = (props) => {

  const { t } = useLocale();

  return (
    <ModalGridItem
      iconPath={mdiPhone}
      label={t('Alarm_Detail_Contact.Phone_Call.Title')}
      subtitle={t('Alarm_Detail_Contact.Phone_Call.Subtitle')}
      onClick={props.onClick}
    />
  );

};
